import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatTokens = (n: number) => {
  if (n >= 1_000_000)
    return `${(n / 1_000_000).toLocaleString(undefined, {
      maximumFractionDigits: 1,
    })}M`
  if (n >= 100_000) return `${Math.round(n / 1_000)}k`
  return n.toLocaleString()
}
